import type {
  ICheckboxStyleProps,
  ICheckboxStyles,
} from "@fluentui/react/lib/Checkbox";
import { concatStyleSets } from "@fluentui/react/lib/Styling";
import type { IStyleFunctionOrObject } from "@fluentui/react/lib/Utilities";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import type { ActionControlSize } from "@1js/acui-common";

const checkboxSmallStyles: Partial<ICheckboxStyles> = {
  root: {
    height: 24,
    lineHeight: 24,
  },
  text: {
    fontSize: 12,
    marginLeft: 0,
  },
  checkbox: {
    height: 16,
    width: 16,
  },
};

export const getMergedCheckboxSizedStyles = (
  externalStyles: IStyleFunctionOrObject<ICheckboxStyleProps, ICheckboxStyles>,
  size: ActionControlSize | undefined
): IStyleFunctionOrObject<ICheckboxStyleProps, ICheckboxStyles> => {
  if (!size) {
    return externalStyles || {};
  }
  return (props: ICheckboxStyleProps) => {
    return concatStyleSets(
      checkboxSmallStyles,
      typeof externalStyles === "function"
        ? externalStyles(props)
        : externalStyles
    );
  };
};

export const getCheckboxSizedStyles = memoizeFunction(
  (
    size: ActionControlSize | undefined
  ): IStyleFunctionOrObject<ICheckboxStyleProps, ICheckboxStyles> => {
    return size ? concatStyleSets(checkboxSmallStyles) : {};
  }
);
